import PaymentEdit from '@/controllers/payment/payment-edit';
import { maxLength } from 'vuelidate/lib/validators';

export default {
  extends: PaymentEdit,
  name: 'customPaymentEdit',

  data() {
    const base = PaymentEdit.data.call(this);
    return {
      ...base,
      errors: null,
      paymentData: {
        ...base.paymentData,
        invoice_number: '',
      },
    };
  },

  validations() {
    const rules = PaymentEdit.validations.call(this);
    return {
      ...rules,
      paymentData: {
        ...rules.paymentData,
        invoice_number: {
          maxLength: maxLength(20),
        },
      },
    };
  },
};
